/* eslint-disable complexity */
import { Alert } from '..';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { reset } from 'app/store/features/boardColumnSlice';
import { setRoute } from 'app/store/features/previousRouteSlice';
import { setCreatePolicyModelInvisible } from 'app/store/features/privacyPagePermissionSlice';
import { setChanges } from 'app/store/features/privacyPersistedSlice';
import { deletePolicyByCache } from 'app/store/features/privacySlice';
import { setAlertOpen } from 'app/store/features/toggleSidebarSlice';
import { ColorsV2 } from 'app/constants/color';
import appService from 'app/services/appService';

const SubMenu = ({ item }) => {
  const [nav, setNav] = useState('/home');
  const [open, setOpen] = useState(false);
  const [subNav, setSubNav] = useState(false);

  const location = useLocation();
  const sidebar = useSelector(state => state.toggleSidebar.isSidebarToggled);
  const alert = useSelector(state => state.toggleSidebar.isAlertOpen);
  const changes = useSelector(state => state.privacyPersisted.changes);
  const withoutTemplate = useSelector(state => state.privacyPersisted.WithoutTemplate);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('translation', { keyPrefix: 'routes' });

  const handleClick = title => {
    if (title === t('route_5')) {
      !alert && appService.logout();
    }
  };

  const handleSubClick = () => {
    if (
      location.pathname.includes('edit-user') ||
      location.pathname === '/add-user' ||
      location.pathname === '/settings'
    ) {
      alert && setOpen(true);
    } else if (changes) {
      setOpen(true);
    }
  };

  const cancelConfirmation = () => {
    dispatch(deletePolicyByCache(withoutTemplate?.policyType)).then(() => {
      dispatch(setChanges(false));
      navigate(nav);
      setOpen(false);
    });
  };

  const renderIconBox = (img, selectedImg, link) => {
    const icon = link === location.pathname ? selectedImg : img;
    const isUrl = typeof icon === 'string';

    return (
      <Box sx={{ width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {isUrl ? (
          <Box component="img" src={icon} alt="icon" sx={{ width: 16, height: 16 }} />
        ) : (
          <Box sx={{ '& svg': { width: 16, height: 16 } }}>{icon}</Box>
        )}
      </Box>
    );
  };

  const textVariant = 'body2';

  return (
    <>
      <Box
        onClick={
          item.subNav
            ? () => setSubNav(!subNav)
            : () => {
                handleClick(item.title);
                (alert || changes) && setOpen(true);
                !(alert || changes) && navigate(item.link);
                setNav(item.link);
                dispatch(setCreatePolicyModelInvisible());
                dispatch(reset());
              }
        }
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: '0.25em 0.5em',
          m: '0.25em 0',
          backgroundColor: item.link === location.pathname ? ColorsV2.primary : 'transparent',
          color: 'white',
          cursor: 'pointer',
          position: item.title === t('route_5') ? 'absolute' : 'relative',
          bottom: item.title === t('route_5') ? 0 : 'auto',
          '&:hover': {
            backgroundColor: ColorsV2.primary,
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
          {renderIconBox(item.icon, item.selectedIcon, item.link)}
          {!sidebar && (
            <Typography
              variant={textVariant}
              sx={{ color: ColorsV2.white, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {item.title}
            </Typography>
          )}
        </Box>
        {!sidebar && item.subNav && (
          <img src={subNav ? item.iconOpened : item.iconClosed} alt='' />
        )}
      </Box>

      {subNav &&
        item.subNav.map((subItem, index) => (
          <Box
            key={index}
            onClick={() => {
              subItem.link !== location.pathname && handleSubClick();
              setNav(subItem.link);
              !(alert || changes) && navigate(subItem.link);
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5em',
              p: '0.25em 0.5em',
              ml: '10px',
              width: '100%',
              backgroundColor:
                subItem.link === location.pathname ? ColorsV2.primary : 'transparent',
              color: 'white',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: ColorsV2.primary,
              },
            }}
          >
            {renderIconBox(subItem.icon, subItem.selectedIcon, subItem.link)}
            {!sidebar && (
              <Typography
                variant={textVariant}
                sx={{ color: ColorsV2.white, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {subItem.title}
              </Typography>
            )}
          </Box>
        ))}

      <Alert
        open={open}
        title={
          location.pathname.includes('edit-user')
            ? t('route_6')
            : location.pathname === '/settings'
            ? t('route_7')
            : location.pathname.includes('board')
            ? t('exit_warning')
            : t('route_8')
        }
        text={
          location.pathname.includes('edit-user')
            ? t('route_9')
            : location.pathname === '/settings'
            ? t('route_10')
            : location.pathname.includes('board')
            ? t('route_13')
            : t('route_11')
        }
        setOpen={setOpen}
        handleCancel={() => setOpen(false)}
        handleClose={() => setOpen(false)}
        handleConfirmation={
          location.pathname.includes('board')
            ? cancelConfirmation
            : () => {
                setOpen(false);
                navigate(nav);
                dispatch(setAlertOpen(false));
                dispatch(setRoute({ pathname: '/users' }));
              }
        }
      />
    </>
  );
};

export default SubMenu;